export default "__VITE_ASSET__gi6afq6e__"